import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../../app/guards'
import { NewContractPage } from '../../../../features/contracts/contract-form-page'
import { contractNewSearchSchema } from '../../../../features/contracts/search'

export const Route = createFileRoute('/_app/service/contracts/new')({
  staticData: { crumb: 'serviceContractNew' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'contracts.manage'),
  validateSearch: contractNewSearchSchema,
  component: NewContractPage,
})
